const ESC_MAP = {
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#x27;',
};

/**
 *HTMLEncode specifial characters ",',<,> as input validation
 *Reference: dashboard/client/js/main/support/utils.js to keep the same validation+
 *Citation: https://stackoverflow.com/questions/1787322/htmlspecialchars-equivalent-in-javascript
 */
export const htmlEncoder = (value: string) => {
  if (typeof value !== 'string' || value === '') {
    return value;
  }

  return value.replace(/[<>'"]/g, function (char) {
    return ESC_MAP[char];
  });
};
